$(function() {

    $(window).on('scroll', function() {
        if ($(window).scrollTop() > 20) {
            $('header').addClass('inverted');
        } else {
            $('header').removeClass('inverted');
        }
    });

    // Image Protection - Prevent right-click and downloading
    // Disable right-click context menu on images
    $(document).on('contextmenu', 'img', function(e) {
        e.preventDefault();
        return false;
    });

    // Disable image dragging
    $(document).on('dragstart', 'img', function(e) {
        e.preventDefault();
        return false;
    });

    // Prevent image selection
    $(document).on('selectstart', 'img', function(e) {
        e.preventDefault();
        return false;
    });

    // Disable save image shortcuts (Ctrl+S, Cmd+S)
    $(document).on('keydown', function(e) {
        if ((e.ctrlKey || e.metaKey) && e.key === 's') {
            e.preventDefault();
            return false;
        }
    });

    // Prevent long press on mobile devices
    $(document).on('touchstart', 'img', function() {
        var timer;
        var $img = $(this);
        
        timer = setTimeout(function() {
            // Long press detected, prevent default behavior
            $img.on('touchend touchcancel', function(e) {
                e.preventDefault();
                $(this).off('touchend touchcancel');
            });
        }, 500);
        
        $img.on('touchend touchcancel', function() {
            clearTimeout(timer);
        });
    });

    // Additional protection: replace image URLs in developer tools
    if (window.console && window.console.log) {
        var originalLog = console.log;
        console.log = function() {
            // Filter out image URLs from console
            var args = Array.prototype.slice.call(arguments);
            var filtered = args.map(function(arg) {
                if (typeof arg === 'string' && arg.match(/\.(jpg|jpeg|png|gif|webp)/i)) {
                    return '[Protected Image]';
                }
                return arg;
            });
            originalLog.apply(console, filtered);
        };
    }
});